import React from 'react'
import Riddles from '../Components/Riddles'

function Sites(props) {
  return(
    <p>{props.text} <a target="_blank" rel="noreferrer"
    href={props.link}>{props.link}</a></p>
  )
}

function Home() {
  return (
    <div>
      <section>
        <h1>Closed Eyes Arg</h1>
        <p>This website will undergo updates reguarly. To ensure that you're up to date, be sure to clear the cache of the pages by <b>holding Shift</b> while <b>clicking the reload button</b>.</p>
        <Sites text='Our Tumblr:' link='https://closed-eyes-arg.tumblr.com/'/>
        <Sites text="What do you see in your mind's eye?" link='https://aphantasia.com/vviq/'/>
        <Sites text="Open the gates. Enter the dreaming." link='https://discord.gg/6RjBjkNr'/>
        <p className="description">A person's capacity for mental visualisation should not be confused with their capacity for imagination. People with limited or no mental visualisation are still able to imagine concepts, just not picture them. Also note that a person's mental perception is not necessarily limited to the visual kind - this can also be related to hearing, smell, taste or touch, and people with low mental imagery levels may often base their mental perception around these senses.</p>
      </section>
      <Riddles/>
    </div>
  )
}

export default Home
